export type Status =
  | "Applied"
  | "Screening"
  | "Interview"
  | "Offer"
  | "Hired"
  | "Rejected";

export interface Note {
  id: string;
  text: string;
  createdAt: string;
}

export interface Candidate {
  id: string;
  name: string;
  email: string;
  role: string;
  status: Status;
  appliedDate: string;
  notes: Note[];
}

export interface Role {
  id: string;
  title: string;
  department: string;
  location?: string;
}

export const getStatusColor = (status: Status): string => {
  switch (status) {
    case "Hired":
      return "green";
    case "Offer":
      return "cyan";
    case "Rejected":
      return "red";
    case "Interview":
      return "purple";
    case "Screening":
      return "orange";
    default:
      return "blue"; // Applied
  }
};
